/**
 * Canonical GST/tax rates — mirrors the backend `TAX_RATES` constant.
 *
 * Use these instead of hardcoding rates, percentages, or the room threshold:
 *   - RATE    -> fraction (e.g. 0.05) for GST-exclusive/inclusive math
 *   - PERCENT -> whole number (e.g. 5) for display and slab selectors
 *
 * Room slab: 18% if a room-night is greater than ROOM.THRESHOLD, else 5%.
 */
export const TAX_RATES = {
  ROOM: {
    LOW: { RATE: 0.05, PERCENT: 5 },
    HIGH: { RATE: 0.18, PERCENT: 18 },
    THRESHOLD: 7500, // ₹7,500 per night threshold
  },
  FOOD: {
    RATE: 0.05,
    PERCENT: 5,
  },
  ACTIVITY: {
    RATE: 0.18,
    PERCENT: 18,
  },
};
